<template>
	<v-app>
		<nav-drawer />
		<v-main>
			<dialog-disabled />
			<menu-top />
			<div class="gum-container">
				<div class="title text-center primary--text py-8">Мастер-классы по фигурному катанию со школой Анастасии Гребенкиной</div>

				<v-img :src="Banner001" />

				<v-row class="section-info my-0">
					<v-col class="d-flex align-center" cols="12" sm="6" :style="style()">
						<div class="pa-12 white--text">
							<p class="subheader" style="line-height: 100%">
								Приглашаем <br />
								на мастер-классы <br />
								по фигурному катанию
							</p>
							<p>
								На ГУМ-Катке пройдут бесплатные мастер-классы по фигурному катанию от амбассадоров компании Royal Skate RS YG PRO и школы 
								фигурного катания Анастасии Гребенкиной.
							</p>
							<p>
								Все участники мастер-классов смогут не только научиться с легкостью исполнять базовые элементы фигурного катания – скольжение, 
								вращения, прыжки, шаги, но и почувствовать настоящую радость от выступления на льду. А так же получить памятные подарки от Royal Skate.
							</p>
							<p class="subheader" style="line-height: 100%">
								Анастасия Гребенкина
							</p>
							<p>
								Руководитель собственной школы фигурного катания. Мастер спорта международного класса. Бронзовый призер этапа Кубка Мира. 
								Многократная победительница Международных турниров, участница Чемпионатов Европы, Мира и Олимпийских игр. Победитель 
								Ледового шоу "Танцы на льду" в паре с Сергеем Лазаревым и "Звездный лед" в паре с Максимом Авериным и Александром Беловым.
							</p>
							<p>
								Анастасия Гребенкина является основоположником любительского фигурного катания в России. В 2011 году ею была создана 
								уникальная авторская методика тренировок по фигурному катанию для детей и взрослых, состоящая из 8 уровней обучения. 
								Данная методика легла в основу обучения всех любительских школ в России.
							</p>
						</div>
					</v-col>
					<v-col cols="12" sm="6" class="px-0 py-0">
						<v-img :src="Image001" height="100%" />
					</v-col>
				</v-row>

				<v-row class="section-info my-0">
					<v-col cols="12" sm="6" class="pa-0">
						<v-img :src="Image002" height="100%" />
					</v-col>
					<v-col class="d-flex align-center ma-0" cols="12" sm="6" >
						<div class="primary--text pa-12" style="width:100%">
							<p class="subheader" style="line-height: 100%">
								Добрин Сергей
							</p>
							<p>
								Мастер спорта международного класса по фигурному катанию.
							</p>
							<p>
								Участник чемпионатов Европы и Мира.
							</p>
							<p>
								Бронзовый призёр чемпионата России.
							</p>
							<p>
								Тренер академия фигурного катания города Москвы.
							</p>
						</div>	
					</v-col>
				</v-row>


				<v-row class="section-info my-0">
					<v-col class="d-flex align-center" cols="12" sm="6" :style="style()">
						<div class="pa-12 white--text" style="width:100%">
							<p class="subheader" style="line-height: 100%">
								Леонтьева Софья
							</p>
							<p>
								Заслуженный мастер спорта в танцах на льду.
							</p>
							<p>
								Член сборной России.
							</p>
							<p>
								<strong>Мастерский уровень:</strong>
							</p>
							<p>
								Гран-При России – 3 бронзовые медали
							</p>
							<p>
								<strong>Юниорский уровень:</strong>
							</p>
							<p>
								Гран-При России – 2 золотые медали
							</p>
							<p>
								Финал Гран-При России – 1 золотая медаль
							</p>
							<p>
								Первенство России – 1 серебряная медаль
							</p>
							<p>
								JGP – 1 серебряная медаль
							</p>
						</div>
					</v-col>
					<v-col cols="12" sm="6" class="px-0 py-0">
						<v-img :src="Image003" height="100%" />
					</v-col>
				</v-row>


				<v-row class="section-info my-0">
					<v-col cols="12" sm="6" class="pa-0">
						<v-img :src="Image005" height="100%" />
					</v-col>
					<v-col class="d-flex align-center ma-0" cols="12" sm="6" >
						<div class="primary--text pa-12" style="width:100%">
							<p class="subheader" style="line-height: 100%">
								Дарио Чиризано
							</p>
							<p>
								Член сборной России по фигурному катанию.
							</p>
							<p>
								Победитель Юношеских олимпийских игр в Лозанне 2020.
							</p>
							<p>
								Действующий бронзовый призёр Чемпионата России.
							</p>
						</div>	
					</v-col>
				</v-row>

				<v-row class="section-faq my-0 py-0">
					<v-col class="d-flex align-center" cols="12" sm="6" :style="style()">
						<div class="white--text pa-6">
							<div class="q"><strong>Когда?</strong></div>
							<div class="a">
								Декабрь: 7 (Гребенкина Анастасия), 14 (Добрин Сергей), 21 (Гребенкина Анастасия)<br />
								Январь: 11 (Добрин Сергей), 18 (Дарио Чиризано), 25 (Гребенкина Анастасия)<br />
								Февраль: 1 (Леонтьева Софья), 8 (Добрин Сергей), 15 (Гребенкина Анастасия), 22 (Гребенкина Анастасия)<br />
								Начало: 09:00, 10:30
							</div>

							<div class="q"><strong>Возрастные ограничения?</strong></div>
							<div class="a">
								Если Вы старше 6 лет и умеете кататься на коньках, то Вы можете стать участником мастер-класса на ГУМ-катке.
							</div>

							<div class="q"><strong>Обращаем ваше внимание:</strong></div>
							<ul class="a">
								<li>Количество мест ограничено – 30 чел</li>
								<li>Вы можете принять участие в мастер-классах только один раз за сезон.</li>
								<li>
									Если вы хотите прийти на мастер-класс с вашим ребенком, пожалуйста, получите бесплатный билет 
									сопровождения в кассе ГУМ-Катка перед началом сеанса. Билет сопровождения не дает возможности 
									выхода на лед. Для получения бесплатного билета сопровождения на кассе нужно показать распечатанный билет на мастер-класс.
								</li>
								<li>Пожалуйста, оставляйте актуальные e-mail адреса и номера телефонов, чтобы мы могли связаться с вами в случае изменения даты.</li>
								<li>Глубина записи – 6 дней.</li>								
							</ul>
						</div>
					</v-col>
					<v-col cols="12" sm="6" class="pa-0 my-0">
						<v-img :src="Image004" height="100%" class="my-0 pa-0" />
					</v-col>
				</v-row>

				<v-row  class="mt-0" :style="`background: ${accent}`">
					<v-col cols="12" class="px-10 py-8 d-flex align-center justify-space-between flex-wrap text-center">
						<div class="text-left white--text fhr-request-label-text">
							<div>Мастер-класс</div>
							<div><b>09:00</b> «Фигурное катание»</div>
						</div>
						<div v-if="CurrentDate" class="fhr-request-btn-container">
							<v-btn block dark outlined class="rounded-0 mx-auto py-8" @click="OpenWidget(3, 31, '8670671')">
								Отправить заявку ( <u>{{ CurrentDateDisplay }}</u> )
							</v-btn>
						</div>
						<v-alert class="mb-0" v-else type="warning">Запись на мастер-класс открывается за 6 дней</v-alert>
					</v-col>
				</v-row>

				<v-row :style="`background: ${primary}`">
					<v-col cols="12" class="py-8 px-10 d-flex align-center justify-space-between flex-wrap text-center">
						<div class="text-left white--text fhr-request-label-text">
							<div>Мастер-класс</div>
							<div><b>10:30 </b> «Фигурное катание»</div>
						</div>
						<div v-if="CurrentDate" class="fhr-request-btn-container">
							<v-btn block dark outlined class="rounded-0 mx-auto py-8" @click="OpenWidget(3, 32, '8670672')">
								Отправить заявку ( <u>{{ CurrentDateDisplay }}</u> )
							</v-btn>
						</div>
						<v-alert class="mb-0" v-else type="warning">Запись на мастер-класс открывается за 6 дней</v-alert>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12">
						<SectionGalleryFigure />
					</v-col>
				</v-row>

				<the-footer />
			</div>
		</v-main>
	</v-app>
</template>

<script lang="ts">
import './style.less';

import Vue from 'vue';
import MenuTop from './components/MenuTop.vue';
import NavDrawer from './components/NavDrawer.vue';
import DialogDisabled from './components/Generic/DialogDisabled.vue';
import TheFooter from './components/Generic/TheFooter.vue';
import EShopWidget from './codebase/widget.script';
import SectionGalleryFigure from './components/SectionGalleryFigure.vue';

export default Vue.extend({
	components: { MenuTop, NavDrawer, DialogDisabled, TheFooter, SectionGalleryFigure },
	name: 'App',

	data: () => ({
		Today: new Date(),
		Banner001: require('./assets/images/figure/2025/Image_1.png'),
		Image001: require('./assets/images/figure/2025/Image_2.png'),
		Image002: require('./assets/images/figure/2025/Image_3.png'),
		Image003: require('./assets/images/figure/2025/Image_4.png'),
		Image004: require('./assets/images/figure/2025/Image_5.png'),
		Image005: require('./assets/images/figure/2025/Image_6.png'),
		CurrentDate: null as null | string,
		CurrentDateDisplay: null as null | string,
		Dates: [
			new Date('2025/12/07 10:00'),
			new Date('2025/12/14 10:00'),
			new Date('2025/12/21 10:00'),
			new Date('2026/01/11 10:00'),
			new Date('2026/01/18 10:00'),
			new Date('2026/01/25 10:00'),
			new Date('2026/02/01 10:00'),
			new Date('2026/02/08 10:00'),
			new Date('2026/02/15 10:00'),
			new Date('2026/02/22 10:00'),
		],
	}),
	created(): void {
		let script = document.createElement('script');
		script.src = 'widget_shop.js';
		script.type = 'text/javascript';
		document.head.append(script);
		this.Dates.every((date: Date) => {
			let d = new Date(date);
			if (this.Today.getTime() < d.getTime()) {
				let minDate = new Date(d.setDate(d.getDate() - 5));
				if (this.Today.getTime() >= minDate.getTime()) {
					this.CurrentDate = date.toISOString().split('T')[0];
					this.CurrentDateDisplay = date.toLocaleDateString().replace('/', '.');
					return false;
				}
			}
			return true;
		});
	},
	methods: {
		OpenWidget(id: number, tariff: number, seance: string) {
			let platform = window as unknown as EShopWidget;
			platform.widgetOpenMaster(id, tariff, seance, this.CurrentDate!, false);
		},
		style() {
			return `background-color: ${this.$vuetify.theme.currentTheme.primary}`;
		},
	},
	computed: {
		primary() {
			return this.$vuetify.theme.currentTheme.primary;
		},
		accent() {
			return this.$vuetify.theme.currentTheme.accent;
		},
	},
});
</script>

<style scoped lang="less">
.section-info {
	.subheader {
		text-align: center;
		font-size: 2rem;
		line-height: normal;
	}

	p {
		font-size: 14px;
		line-height: normal;
	}
}

.section-faq {
	.q {
		font-weight: 500;
	}

	.a {
		font-size: 14px;
		margin-bottom: 12px;
	}
}

.gum-container {
	max-width: 1400px;
	margin-inline: auto;
	overflow: hidden;

	& > .title {
		font-size: 1.5rem !important;
	}
}

.fhr-request-btn-container {
	width: 100%;
	max-width: 350px;
}

.fhr-request-label-text{
	min-width: 300px;
}
</style>